import * as React from 'react'
import './styles.css'
// libs
import { motion } from 'motion/react'
// views
import UpsetChart from '../News/components/upsetChart'
import AnimatedContainer from '../../ui/AnimatedContainer/animatedContainer'
import {
  descriptionAnimation,
  titleAnimation,
} from '../../../constants/animation'
import { upsetData, upsetSetNames } from '../News/components/upsetChart/data'
import DownloadModal from '../News/components/downloadModal'
// assets
import Glow from '../../glows'
import OhioMap from '../../../assets/imgs/ohioProject/ohioMap.png'

const NSF = () => {
  const [isOpen, setIsOpen] = React.useState(false)

  return (
    <section className='overview-section nsf-section-wrapper'>
      <div className='box'>
        <Glow />
        <Glow position='right' />

        <AnimatedContainer className='ohio-grid'>
          <div>
            <motion.span className='overview-title' variants={titleAnimation}>
              AI-Powered Skills Mapping and Regional Strategy for Emerging
              Industries
            </motion.span>
            <motion.p className='description' variants={descriptionAnimation}>
              Pod began mapping jobs from publicly available sources such as
              Google, LinkedIn and Glassdoor. Pod looked at Ohio's 7 economic
              regions as well as neighboring metropolitan areas and curated
              nearly half a million jobs.
            </motion.p>
            <div className='nsf-button-container'>
              <button
                className='nsf-button'
                onClick={() => {
                  setIsOpen(true)
                }}
              >
                Download Report
              </button>
            </div>
          </div>
          <div className='img-container'>
            <img className='news-image' src={OhioMap} alt='Map of ohio' />
          </div>
        </AnimatedContainer>
        <p className='description'>
          Click the blue blocks below to see the most common intersecting
          skillsets
        </p>
        <UpsetChart
          data={upsetData}
          setNames={upsetSetNames}
          setIsOpen={setIsOpen}
        />
        <DownloadModal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          setIsOpen={setIsOpen}
        />
      </div>
    </section>
  )
}

export default NSF
